import { campusApiClient } from './campusApiClient';
export const fetchExercise = async (exerciseId, environment, language, validate) => {
  const [exercise, isRatingPermitted] = await Promise.all([campusApiClient(environment).getExercise(exerciseId, language, validate), campusApiClient(environment).getIsRatingPermitted()]);
  // eslint-disable-next-line prefer-object-spread
  return Object.assign({}, exercise, {
    isRatingPermitted
  });
};
export const fetchExerciseWithProgress = async (exerciseId, environment, language, validate) => {
  const [exercise, progress] = await Promise.all([fetchExercise(exerciseId, environment, language, validate), campusApiClient(environment).getExerciseProgress(exerciseId, language).catch(() => {
    return undefined;
  })]);
  // eslint-disable-next-line prefer-object-spread
  return Object.assign({}, exercise, {
    progress
  });
};